import {
  TopRUSummaryPlanItem,
  TopSQLExecutionPlanAnalysisPlan,
  TopSQLTrendPoint
} from './types'

const UNKNOWN_PLAN_DIGEST = 'N/A'

export const fillTrendPointGaps = (
  points: TopSQLTrendPoint[],
  stepSeconds: number,
  timeRangeValue?: [number, number]
) => {
  if (!points.length || stepSeconds <= 0) {
    return points
  }

  const sortedPoints = [...points].sort(
    (left, right) => left.timestamp - right.timestamp
  )
  const pointMap = new Map(
    sortedPoints.map((point) => [point.timestamp, point.value])
  )
  let startTimestamp = sortedPoints[0].timestamp
  let endTimestamp = sortedPoints[sortedPoints.length - 1].timestamp

  if (timeRangeValue) {
    const [rangeStart, rangeEnd] = timeRangeValue

    while (startTimestamp - stepSeconds >= rangeStart) {
      startTimestamp -= stepSeconds
    }

    while (endTimestamp + stepSeconds <= rangeEnd) {
      endTimestamp += stepSeconds
    }
  }

  const filledPoints: TopSQLTrendPoint[] = []

  for (
    let timestamp = startTimestamp;
    timestamp <= endTimestamp;
    timestamp += stepSeconds
  ) {
    filledPoints.push({
      timestamp,
      value: pointMap.has(timestamp) ? pointMap.get(timestamp)! : 0
    })
  }

  return filledPoints
}

export const buildTopSQLExecutionPlans = ({
  items,
  recordKey,
  statementTotalRU,
  stepSeconds,
  timeRangeValue
}: {
  items: TopRUSummaryPlanItem[]
  recordKey: string
  statementTotalRU: number
  stepSeconds: number
  timeRangeValue: [number, number]
}): TopSQLExecutionPlanAnalysisPlan[] =>
  items.map((item, index) => {
    const planRU = item.total_ru || 0
    const executions = item.exec_count || 0
    const totalLatencyNs = item.duration_ns || 0
    const planDigest = item.plan_digest || UNKNOWN_PLAN_DIGEST

    return {
      key: item.plan_digest
        ? `${recordKey}:${item.plan_digest}`
        : `${recordKey}:unknown-plan:${index}`,
      planDigest,
      ru: planRU,
      meanRU: executions > 0 ? planRU / executions : 0,
      share:
        statementTotalRU > 0
          ? Number(((planRU / statementTotalRU) * 100).toFixed(2))
          : 0,
      executions,
      totalLatencyNs,
      meanLatencyNs: executions > 0 ? totalLatencyNs / executions : 0,
      trend: fillTrendPointGaps(
        (item.timestamp_sec || []).map((timestamp, pointIndex) => ({
          timestamp,
          value: item.total_ru_by_time?.[pointIndex] ?? 0
        })),
        stepSeconds,
        timeRangeValue
      ),
      planText: item.plan_text || ''
    }
  })
